import(/* webpackMode: "eager" */ "/app/app/propiedades/page.tsx");
